import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { FieldGroupService } from '../_services';
import * as FieldGroupActions from '../_actions/fieldGroup';

@Injectable({
  providedIn: 'root',
})
export class FieldGroupEffects {
  loadFieldGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldGroupActions.loadFieldGroups),
      mergeMap(() =>
        this.fieldGroupService.getFieldGroups().pipe(
          map((fieldGroups) => FieldGroupActions.loadFieldGroupsSuccess({ fieldGroups })),
          catchError((error) => of(FieldGroupActions.loadFieldGroupsFailure({ error })))
        )
      )
    )
  );

  addFieldGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldGroupActions.addFieldGroup),
      mergeMap(({ fieldGroup }) =>
        this.fieldGroupService.saveFieldGroup(fieldGroup).pipe(
          map((savedFieldGroup) =>
            FieldGroupActions.addFieldGroupSuccess({ fieldGroup: savedFieldGroup })
          ),
          catchError((error) => of(FieldGroupActions.addFieldGroupFailure({ error })))
        )
      )
    )
  );

  updateFieldGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldGroupActions.updateFieldGroup),
      mergeMap(({ fieldGroup }) =>
        this.fieldGroupService.saveFieldGroup(fieldGroup).pipe(
          map((updatedFieldGroup) =>
            FieldGroupActions.updateFieldGroupSuccess({ fieldGroup: updatedFieldGroup })
          ),
          catchError((error) => of(FieldGroupActions.updateFieldGroupFailure({ error })))
        )
      )
    )
  );

  deleteFieldGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FieldGroupActions.deleteFieldGroup),
      mergeMap(({ id }) =>
        this.fieldGroupService.deleteFieldGroup(id).pipe(
          map(() => FieldGroupActions.deleteFieldGroupSuccess({ id })),
          catchError((error) => of(FieldGroupActions.deleteFieldGroupFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private fieldGroupService: FieldGroupService
  ) {}
}
